<div>
    <div class="mat-elevation-z8">
        <div class="tableHolder table-responsive p-3 table-container-scrollable">
            <table mat-table [dataSource]="dataSource" matSort matSortDirection="asc" class="table">
                <!-- supplierName -->
                <ng-container matColumnDef="supplierName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Supplier Name</th>
                    <td mat-cell *matCellDef="let element">
                        {{ element.supplierName }}
                    </td>
                </ng-container>

                <!-- transactionType -->
                <ng-container matColumnDef="transactionType">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Transaction Type</th>
                    <td mat-cell *matCellDef="let element">
                        {{ formatTransactionType(element.transactionType) }}
                    </td>
                </ng-container>

                <!-- amount -->
                <ng-container matColumnDef="amount">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Amount</th>
                    <td mat-cell *matCellDef="let element">
                        {{ element.amount.value | currency: element.amount.currencyCode }}
                    </td>
                </ng-container>

                <!-- createdBy -->
                <ng-container matColumnDef="createdAt">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Date Added</th>
                    <td mat-cell *matCellDef="let element">
                        {{ element.createdAt }}
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="columns"></tr>
                <tr
                    mat-row
                    *matRowDef="let row; columns: columns"
                    (click)="getDetailedSupplierChargeTransactions(row)"
                    [ngClass]="{ 'clickable-row': row.supplierDetailedPaymentTransactions != null }"
                ></tr>
            </table>
            <div class="totals-summary mt-3">
                <div class="d-flex align-items-center px-5 mb-2" style="border-radius: 5rem; min-height: 20px;">
                    <div style="width: 27%;"></div> 
                    
                    <div style="width: 28%; text-align: left;">
                        <span class="text-black montserrat-bold text-uppercase">Total Campaign Fees (Excl. VAT):</span>
                    </div>
                    
                    <div style="width: 33%; text-align: left;">
                        <span class="text-black montserrat-bold">{{ totalCampaignFees | currency }}</span>
                    </div>

                    <div style="width: 12%;"></div>
                </div>

                <div class="d-flex align-items-center px-5" style="border-radius: 5rem; min-height: 10px;">
                    <div style="width: 27%;"></div>
                    
                    <div style="width: 28%; text-align: left;">
                        <span class="text-black montserrat-bold text-uppercase">Total MF Charges:</span>
                    </div>
                    
                    <div style="width: 33%; text-align: left;">
                        <span class="text-black montserrat-bold">{{ totalMfCharges | currency }}</span>
                    </div>

                    <div style="width: 12%;"></div>
                </div>
            </div>
        </div>
    </div>
</div>
